<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.分类名称') + '：'" required>
        <nation-input v-model="formData.recipeCategoryLang" />
      </el-form-item>

      <el-form-item :label="$t('lang.描述') + '：'">
        <nation-input v-model="formData.recipeCategoryDescription" type="textarea" :rows="5" />
      </el-form-item>

      <el-form-item prop="sortNum" :label="$t('lang.排序') + '：'">
        <el-input v-model.number="formData.sortNum" :placeholder="$t('lang.排序')" />
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" prop="lang" >
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>

      </el-form-item>

      <el-form-item :label="$t('lang.图片') + '：'">
          <pic-upload
              :limit="1"
              :action="api.upload"
              :download-url="api.downloadImg"
              :data="{category: 'RECIPE'}"
              v-model="formData.cover" />
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>

import {handleFilterLang} from "../../utlis/utlis";
import {filterParams, loadSysSettLang} from "../../js/common";
import NationInput from "../../components/nation/NationInput";
import PicUpload from "../../components/pic-upload/PicUpload";
export default {
  name: "CategorySetAdd",
  components: {PicUpload, NationInput},
  data() {
    return {
      api: {
        add: this.$api.recipeCategory.add,
        upload: this.$api.file.upload,
        downloadImg: this.$api.file.downloadImg,
      },
      formErrorMsg: {name: ''},
      formData: {
        lang: '',
        brandOwnerCode: "",
        recipeCategoryLang: {},
        recipeCategoryDescription: {},
        sortNum: null,
      },
      langRadio: '',
      categoryName: '',
    }

  },
  computed: {
    rules() {
      return {
        lang: [
          {required: true, message: this.$t('lang.主语言不能为空'), trigger: 'blur'}
        ],
      }
    },
    langList() {
      const vm = this;
      let list = handleFilterLang(this);
      if(list && list.length) {
        list.forEach(i => {
          vm.$set( this.formData['recipeCategoryLang'], i.value, '');
        });
      }
      return list;
    },

  },
  methods: {
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let data = {...vm.formData};
          // let langList = data['recipeCategoryLang'];
          data['recipeCategoryLang'] = filterParams(data['recipeCategoryLang']);
          data['recipeCategoryDescription'] = filterParams(data['recipeCategoryDescription']);
          data['brandOwnerCode'] = vm.$store.state.userInfo['brandOwnerCode'];

          vm.$http.post(vm.api.add, data).then((resp) => {
            if (resp.data.status === 200) {

              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              this.$bus.$emit("refreshRecipeCategory");
              vm.$router.back();
            } else if (resp.data.status === 400) {

              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs[form].resetFields();
      for (const key in this.formData.recipeCategoryLang) {
        this.formData.recipeCategoryLang[key] = '';
      }
    }
  }
  ,
  async created() {
    await loadSysSettLang(this);
    // let vm = this;
  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}


.lang-box {
  display: flex;
  margin-top: 14px;
}


/deep/ .el-radio {
  line-height: 40px;
}

</style>
